export default "__VITE_ASSET__325d7d23__"